import {updateViableDatePickerDays} from "@js/parts/search/functions/searchfilterbox/updateViableDatePickerDays";
import {updateDateRangeValue} from "@js/parts/search/functions/searchfilterbox/updateDateRangeValue";
import {triggerDocumentEvent} from "@js/globalFunctions/events";

export function updateSearchMode()
{
	const mode = $('#search-mode-toggle').is(':checked') === false ? dataholder.searchModes.ferie : dataholder.searchModes.miniferie;
	if(mode !== dataholder.searchMode)
	{
		dataholder.searchMode = mode;
		updateSearchToggleDisplay();
		updateSearchParametersDisplay();
		triggerDocumentEvent('triggerResourceCondition',{includeCss: true,where:'search_mode'});
	}
}

function updateSearchParametersDisplay()
{
	if(dataholder.searchModes.ferie === dataholder.searchMode)
	{
		$('.hide-when-miniferie').removeClass('hidden');
		$('.show-when-miniferie').addClass('hidden');
	}
	else
	{
		$('.hide-when-miniferie').addClass('hidden');
		$('.show-when-miniferie').removeClass('hidden');
		if(dataholder.dateRangeDatePicker === false)
		{
			if(typeof HotelDatepicker !== 'undefined')
			{
				initHotelDatePicker();
			}
			else
			{
				let attempts = 0;
				const interval = setInterval(() => {
					if(typeof HotelDatepicker !== 'undefined')
					{
						initHotelDatePicker();
						clearInterval(interval)
					}
					else
					{
						attempts++;
						if(attempts > 10)
						{
							clearInterval(interval)
						}
					}
				},200)
			}
		}
	}
}

function initHotelDatePicker()
{
	const input = document.getElementById('dateRange');
	dataholder.dateRangeDatePicker = new HotelDatepicker(input, {
		format: 'DD-MM-YYYY',
		startOfWeek: 'monday',
		minNights: 3,
		maxNights: 5,
		animationSpeed: '.2s',
		moveBothMonths: true,
		hoveringTooltip: function(nights, startTime, hoverTime) {
			return false;
		},
		i18n: {
			selected: wpTranslatedStrings.hotelDatePicker.selected,
			night: wpTranslatedStrings.hotelDatePicker.night,
			nights: wpTranslatedStrings.hotelDatePicker.nights,
			button: wpTranslatedStrings.hotelDatePicker.button,
			'checkin-disabled': wpTranslatedStrings.hotelDatePicker['checkin-disabled'],
			'checkout-disabled': wpTranslatedStrings.hotelDatePicker['checkout-disabled'],
			'day-names-short': wpTranslatedStrings.hotelDatePicker['day-names-short'],
			'day-names': wpTranslatedStrings.hotelDatePicker['day-names'],
			'month-names-short': wpTranslatedStrings.hotelDatePicker['month-names-short'],
			'month-names': wpTranslatedStrings.hotelDatePicker['month-names'],
			'error-more': wpTranslatedStrings.hotelDatePicker['error-more'],
			'error-more-plural': wpTranslatedStrings.hotelDatePicker['error-more-plural'],
			'error-less': wpTranslatedStrings.hotelDatePicker['error-less'],
			'error-less-plural': wpTranslatedStrings.hotelDatePicker['error-less-plural'],
			'info-more': wpTranslatedStrings.hotelDatePicker['info-more'],
			'info-more-plural': wpTranslatedStrings.hotelDatePicker['info-more-plural'],
			'info-range': wpTranslatedStrings.hotelDatePicker['info-range'],
			'info-default': wpTranslatedStrings.hotelDatePicker['info-default']
		},
		onDayClick: function() {
			updateViableDatePickerDays();
			let lastSelected = $('.datepicker__month-day--selected').length;
			let i = 0;
			const interval = setInterval(() => {
				const currentSelected = $('.datepicker__month-day--selected').length;
				if(lastSelected === currentSelected)
					updateViableDatePickerDays();
				
				i++;
				if(i > 10)
					clearInterval(interval)
			},50)
			$('#close-dateRange').removeAttr('disabled')
		},
		onOpenDatepicker: function() {
			updateViableDatePickerDays();
		}
	});
	input.addEventListener('afterClose', function () {
		updateDateRangeValue();
	}, false);
}



export function updateSearchToggleDisplay()
{
	let text;
	const mode = dataholder.searchMode;
	if(mode === dataholder.searchModes.ferie)
	{
		text = $('#search-mode-toggle-wrapper .left-text').text();
		$('#search-mode-toggle-wrapper').removeClass('right-active').addClass('left-active');
	}
	else
	{
		text = $('#search-mode-toggle-wrapper .right-text').text();
		$('#search-mode-toggle-wrapper').addClass('right-active').removeClass('left-active');
	}
	
	const rightBounds = $('#search-mode-toggle-wrapper .right-text')[0].getBoundingClientRect();
	const leftBounds = $('#search-mode-toggle-wrapper .left-text')[0].getBoundingClientRect();
	let left = 3;
	if(mode !== dataholder.searchModes.ferie){
		left = rightBounds.left - leftBounds.left;
	}
	
	let width = mode === dataholder.searchModes.ferie ? leftBounds.width : rightBounds.width - 3 ;
	
	$('#search-mode-toggle-wrapper .active')[0].style.cssText = 'left:'+left+'px;width:'+width+'px';
	$('#search-mode-toggle-wrapper .active').text(text);
}
